import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDrawer } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';

import { RequestNotificationDialogComponent } from '../../components/request-notification-dialog/request-notification-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { UserService } from 'src/services/user.service';
import { MiscService } from 'src/services/misc.service';
import { EventBusService } from 'src/services/event-bus.service';
import { NotificationsService } from 'src/services/notifications.service';
import { RedirectService } from 'src/services/redirect.service';
import { SidenavbarViewService } from '../../services/sidenavbar-view.service';

@Component({
  selector: 'app-distributor-layout',
  templateUrl: './distributor-layout.component.html',
  styleUrls: ['./distributor-layout.component.css']
})
export class DistributorLayoutComponent implements OnInit, OnDestroy {

	role: any;
	view: any;
	labels: any;
	subcriptions: any[] = [];
	@ViewChild('drawer', { static: false}) drawer: MatDrawer;
	showContent: boolean = false;

  	constructor(
    	private router: Router,
		private route: ActivatedRoute,
		private globalCfgService: GlobalCfgService,
		private userService: UserService,
		private miscService: MiscService,
		private ebService: EventBusService,
		private notifyService: NotificationsService,
		private dialog: MatDialog,
		private redirectService: RedirectService,
		public sidenavbarViewService: SidenavbarViewService
  	) { }

  	ngOnInit() {
    	var user = this.globalCfgService.getLoggedInUser();

		this.route.url.subscribe(
			(url)=> {
				var v = url.values();
				//always the first part is role
				this.role = v.next().value.path;

				if (url.length > 1) {
					this.view = v.next().value.path;
				}
			});
			

		if (!user || Object.keys(user).length == 0) {
			this.router.navigateByUrl('/');
			this.showContent = false;
		} else {

			this.userService.getUserDetail(user['userId']).subscribe(
				(response: any) => {
					this.globalCfgService.setFullUserObj(response);

					if (response.role == 'distributor') {
						window.localStorage.setItem('gcp', response.gcp);
						this.miscService.getLabels(response.gcp).subscribe(
						(labels: any[])=> {
							this.labels = JSON.parse(labels[0].value);
							this.globalCfgService.setSettings({
								labels: this.labels
							});

							// this.miscService.getACL(response.gcp).subscribe(
							// 	(acls: any[])=> {
							// 		var acl = JSON.parse(acls[0].value);

							// 		this.globalCfgService.setAcl(acl);
									if (this.redirectService.redirectUrl != null) {
										this.redirectService.processRedirect(this.role);
									} else {
										this.ebService.onReadySource.next();
									}
									this.showContent = true;
							// 	}
							// );

						});
					}
					
				});
		}

		this.subcriptions.push(this.ebService.toggleDrawerValue$.subscribe(
			drawer => {
				this.drawer.opened = drawer;
			}
		));

		if (Notification.permission === 'default') {
			this.showRequestDialog();
		} else if (Notification.permission === 'granted') {
			// console.log('notifications allowed');
			this.notifyService.requestPermission();
			this.notifyService.receiveMessage();
		}
  	}

	showRequestDialog() {
		const dialogRef = this.dialog.open(RequestNotificationDialogComponent, {
			width: "450px"
		})
	  
		dialogRef.afterClosed().subscribe(result => {
			console.log("The dialog was closed", result);
			if (result.enable === true) {
			  this.enableNotifications();
			}
		});
	}

	enableNotifications() {
		this.notifyService.requestPermission();
		this.notifyService.receiveMessage();
	}

  	ngOnDestroy() {
		this.subcriptions.forEach(s => s.unsubscribe());
	}
}
